import React, { useState, useEffect } from "react";
import "../css/botolan.css";

export default function Botolan() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    "../../assets/agenda/botolan.svg",
    "../../assets/agenda/pemilu.svg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="botolan">
      <div className="slider">
        {slides.map((slide, index) => (
          <article
            key={index}
            className={`move ${index === currentSlide ? "active" : ""}`}
            style={{
              transform: `translateX(-${currentSlide * 100}%)`,
              transition: "transform 0.5s ease-in-out",
              position: "relative",
            }}
          >
            <img src={slide} alt={`slide-${index}`} />
            {index === currentSlide && (
            <button className="l-detail d-flex gap-1 justify-content-center">
                <img className="eye" src="../../assets/agenda/eye.svg"></img>
                <p className="detail-eye">Lihat detail</p>
            </button>
            )}
          </article>
        ))}
      </div>
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => handleClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}
